/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_LockedInputs */

const en_so_status_locked = /** @type {(inputs: So_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked`)
};

/**
* | output |
* | --- |
* | "Locked" |
*
* @param {So_Status_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_locked = /** @type {((inputs?: So_Status_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_locked(inputs)
});